<script setup>
import { useInbox } from 'dashboard/composables/useInbox';
import ShopeeCard from './Cards/ShopeeCard.vue';
import LazadaCard from './Cards/LazadaCard.vue';
import TiktokShopCard from './Cards/TiktokShopCard.vue';
const { isAShopeeInbox, isALazadaInbox, isATiktokShopInbox } = useInbox();
</script>

<template>
  <div>
    <template v-if="isAShopeeInbox">
      <ShopeeCard />
    </template>
    <template v-else-if="isALazadaInbox">
      <LazadaCard />
    </template>
    <template v-else-if="isATiktokShopInbox">
      <TiktokShopCard />
    </template>
  </div>
</template>
